var _excluded = ["css", "height", "width", "iconProps", "onClick", "onChange", "onBlur", "onFocus", "defaultValue", "defaultChecked", "disabled", "name", "required", "value", "checked", "indicatorCss", "variant", "label", "containerProps", "id", "tooltip", "hideBg"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Div, Label, Span } from '@kizi/core-components';
import React, { useEffect, useMemo, useState } from 'react';
import { Icon } from '../components/Icon';
import { withTooltip } from './HOCs/withTooltip';
import { IconV2 } from './IconV2';
var inputStyle = {
  position: 'absolute',
  opacity: 0,
  height: '100%',
  width: '100%',
  zIndex: 9
};
var baseIndicatorCss = {
  borderRadius: '50%',
  bg: 'primary',
  m: '0',
  width: '10px',
  height: '10px',
  left: '5px'
};
var TooltipIcon = withTooltip(IconV2);
export var Radio = function Radio(_ref) {
  var css = _ref.css,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 20 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 20 : _ref$width,
      iconProps = _ref.iconProps,
      onClick = _ref.onClick,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      defaultValue = _ref.defaultValue,
      defaultChecked = _ref.defaultChecked,
      disabled = _ref.disabled,
      name = _ref.name,
      required = _ref.required,
      value = _ref.value,
      checked = _ref.checked,
      indicatorCss = _ref.indicatorCss,
      variant = _ref.variant,
      label = _ref.label,
      containerProps = _ref.containerProps,
      id = _ref.id,
      tooltip = _ref.tooltip,
      hideBg = _ref.hideBg,
      spanProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(checked),
      _useState2 = _slicedToArray(_useState, 2),
      isChecked = _useState2[0],
      setIsChecked = _useState2[1];

  var radioStyle = useMemo(function () {
    var style = _objectSpread({
      borderStyle: 'solid',
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      userSelect: 'none',
      borderRadius: '50%',
      height: height,
      width: width,
      minWidth: width
    }, css);

    if (disabled) {
      style['bg'] = 'second.1';
      style['borderColor'] = 'second.1';
      style['&:hover'] = {
        bg: 'second.1',
        borderColor: 'second.1'
      };
    }

    return style;
  }, [disabled, height, width, css]);

  var _id = useMemo(function () {
    return id !== undefined ? id : "".concat(label === null || label === void 0 ? void 0 : label.toString().toLowerCase().replace(/\s/g, ''), "-").concat(Math.floor(Math.random() * 100));
  }, [label]);

  var innerSpanProps = useMemo(function () {
    if (iconProps !== undefined) {
      return {
        children: /*#__PURE__*/React.createElement(Icon, _extends({
          height: "100%",
          width: "100%"
        }, iconProps)),
        width: '100%',
        height: '100%'
      };
    } else {
      return {
        css: _objectSpread(_objectSpread({}, baseIndicatorCss), indicatorCss)
      };
    }
  }, [indicatorCss, iconProps]);

  var _tooltip = useMemo(function () {
    return /*#__PURE__*/React.createElement(Div, {
      minWidth: "200px",
      maxWidth: "260px",
      variant: "primaryContainer",
      dangerouslySetInnerHTML: {
        __html: tooltip || ''
      }
    });
  }, [tooltip]);

  var _label = useMemo(function () {
    return typeof label === 'string' ? /*#__PURE__*/React.createElement(Label, {
      htmlFor: _id,
      variant: "radioGroupItemLabel"
    }, label) : label;
  }, [label]);

  var radioVariant = "inputs.radios.".concat(variant).concat(isChecked ? '.checked' : '');
  useEffect(function () {
    setIsChecked(checked || defaultChecked);
  }, []);
  useEffect(function () {
    setIsChecked(checked);
  }, [checked]);
  return /*#__PURE__*/React.createElement(Span, _extends({
    display: "flex"
  }, containerProps), tooltip && /*#__PURE__*/React.createElement(TooltipIcon, {
    ml: 1,
    position: "relative",
    bottom: "1px",
    name: "info",
    size: 18,
    css: {
      fill: 'main.1'
    },
    _tooltip: _tooltip,
    cursor: "pointer",
    hideBg: hideBg
  }), _label, /*#__PURE__*/React.createElement(Span, _extends({}, spanProps, {
    css: radioStyle,
    variant: radioVariant
  }), /*#__PURE__*/React.createElement("input", {
    type: "radio",
    style: inputStyle,
    onChange: onChange,
    onClick: onClick,
    onBlur: onBlur,
    onFocus: onFocus,
    defaultValue: defaultValue,
    defaultChecked: defaultChecked,
    disabled: disabled,
    name: name,
    required: required,
    value: value,
    checked: checked,
    id: _id
  }), isChecked && /*#__PURE__*/React.createElement(Span, innerSpanProps)));
};